import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_NEWRELIC_BROWSER_ENABLED = createFcmConfig('newrelic_browser_enabled', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
